
import {
    getRanges,
    tooltipFormatter
} from "../../utils/charts";

import { ageIdentifiers } from "../../utils/general";

import * as Highcharts from "highcharts";
import more from "highcharts/highcharts-more";
import maps from "highcharts/modules/map";
import worldMap from "@highcharts/map-collection/custom/world.geo.json";

more(Highcharts);
maps(Highcharts);


export let periodIdentifiers = {

    '3m': {
        'title': 'Letzte 12 Wochen',
        'legend': 'Im Vergleich zu vorherigen 12 Wochen'
    },
    '6m': {
        'title': 'Letzte 6 Monate',
        'legend': 'Im Vergleich zu vorherigen 6 Monaten'
    },
    '12m': {
        'title': 'Letztes Jahr',
        'legend': 'Im Vergleich zu vorherigem Jahr'
    },
    '18m': {
        'title': 'Letze 18 Monate',
        'legend': 'Im Vergleich zu vorherigen 18 Monaten'
    }

};

export let charts = {
    'periodic': null,
    'cumulative': null,
    'rating': null,
    'origins': {
        'map': null,
        'heatmap': null,
        'data': []
    }
};


export let getChangeClass = (chg) => {

    if (chg === 'inf' || chg > 0) {

        return 'change-up';
    }

    if (chg === '-inf' || chg < 0) {

        return 'change-down';
    }

    return 'change-none';

};

export let getChangePercent = (chg, round = false) => {

    if (chg === 'inf' || chg === '-inf') {

        return '∞';

    }

    return `${Math.abs((round) ? Math.round(chg) : chg)}%`;

};

export let setupChartPeriodic = (data) => {

    let chartData = { 'p': [], 'n': []};

    let gap = 0.1;

    for (let dp in data) {

        let cum = data[dp]['pos'] + data[dp]['neg'];

        let ranges = getRanges(cum, data[dp]['pos'], data[dp]['neg'], gap);

        chartData['p'].push(ranges[0]);

        chartData['n'].push(ranges[1]);

    }

    return {

        chart: {
            type: 'columnrange',
            margin: [0, 0, 0, 0]
        },
        title: {
            text: null
        },
        legend: {
            enabled: false
        },
        credits: {
            enabled: false
        },
        tooltip: {
            enabled: false
        },
        xAxis: {
            allowDecimals: true,
            visible: false,
            minPadding: 0,
            maxPadding: 0
        },
        yAxis: {
            allowDecimals: true,
            visible: false,
            minPadding: 0,
            maxPadding: 0
        },
        plotOptions: {
            columnrange: {
                stacking: 'normal',
                borderRadius: '0.44vh'
            },
            series: {
                states: {
                    inactive: {
                        opacity: 1
                    }
                },
                animation: {
                    duration: 500
                }
            }
        },
        series: [
            {
                name: 'pos',
                data: chartData['p'],
                color: '#6AECAB'
            },
            {
                name: 'neg',
                data: chartData['n'],
                color: '#F9407E'
            }
        ]
    };

}

export let setupChartCumulative = (data) => {

    let chartData = [];

    for (let dp in data) {

        chartData.push(
            (data[dp] !== 0) ? data[dp] : null
        );

    }

    return {

        chart: {
            type: 'column',
            margin: [0, 0, 0, 0]
        },
        title: {
            text: null
        },
        legend: {
            enabled: false
        },
        credits: {
            enabled: false
        },
        tooltip: {
            enabled: false
        },
        xAxis: {
            allowDecimals: true,
            visible: false,
            minPadding: 0,
            maxPadding: 0
        },
        yAxis: {
            allowDecimals: true,
            visible: false,
            minPadding: 0,
            maxPadding: 0
        },
        plotOptions: {
            column: {
                borderRadius: '0.27vh'
            },
            series: {
                states: {
                    inactive: {
                        opacity: 1
                    }
                },
                animation: {
                    duration: 500
                }
            }
        },
        series: [
            {
                name: 'basic',
                data: chartData,
                color: {
                    linearGradient: {
                        x1: 0, x2: 1, y1: 0, y2: 1
                    },
                    stops: [
                        [0, '#19CEDB'],
                        [1, '#16A7E8']
                    ]
                }
            }
        ]
    }
}

export let setupChartsAudience = (data) => {

    let genderChart = {
        chart: {
            type: 'pie',
            plotBackgroundColor: null,
            plotBorderWidth: null,
            plotShadow: false,
            borderRadius: 0,
            margin: [0, 0, 0, 0],
            spacingTop: 0,
            spacingBottom: 0,
            spacingLeft: 0,
            spacingRight: 0,
            style: {
                fontFamily: 'Roboto',
                fontWeight: 600
            }
        },
        title: {
            verticalAlign: 'middle',
            floating: true,
            text: data['total'],
            style: {
                fontSize: window.innerHeight * 0.0185 + 'px'
            }
        },
        legend: {
            enabled: false
        },
        credits: {
            enabled: false
        },
        tooltip: {
            enabled: false
        },
        xAxis: {
            minPadding: 0,
            maxPadding: 0
        },
        yAxis: {
            minPadding: 0,
            maxPadding: 0
        },
        plotOptions: {
            pie: {
                size: window.innerHeight * 0.085,
                dataLabels: {
                    enabled: false
                },
                borderWidth: 3
            },
            series: {
                states: {
                    hover: {
                        halo: null
                    }
                }
            }
        },
        series: [
            {
                innerSize: '60%',
                data: [
                    {
                        y: data['gender']['fem'],
                        color: {
                            linearGradient: {
                                x1: 0, x2: 1, y1: 0, y2: 1
                            },
                            stops: [
                                [0, '#FF3782'],
                                [1, '#FF37CA']
                            ]
                        }
                    },
                    {
                        y: data['gender']['mal'],
                        color: {
                            linearGradient: {
                                x1: 0, x2: 1, y1: 0, y2: 1
                            },
                            stops: [
                                [0, '#19CEDB'],
                                [1, '#16A7E8']
                            ]
                        }
                    }
                ]
            }
        ]
    }

    let chartDataAge = {
        'categories': [],
        'fem': [],
        'mal': [],
        'pct': []
    };

    for (const [ageKey, ageValues] of Object.entries(data['age']).sort()) {

        chartDataAge['categories'].push(ageIdentifiers[ageKey]);
        chartDataAge['fem'].push(ageValues['fem']);
        chartDataAge['mal'].push(ageValues['mal']);
        chartDataAge['pct'].push(ageValues['pct']);

    }

    let agesChart = {
        chart: {
            type: 'bar',
            /*margin: [0, 0, 0, 0],*/
            spacingTop: 0,
            spacingBottom: 0,
            /*spacingLeft: 0,*/
            spacingRight: 15
        },
        title: {
            text: null
        },
        legend: {
            enabled: false
        },
        credits: {
            enabled: false
        },
        tooltip: {
            enabled: false
        },
        xAxis: {
            allowDecimals: false,
            categories: chartDataAge['categories'],
            lineWidth: 0,
            /*tickWidth: 0,*/
            labels: {
                step: 1,
                style: {
                    fontFamily: 'Raleway',
                    fontSize: '1.3vh',
                    color: '#383874'
                }
            },
            minPadding: 0,
            maxPadding: 0,

            /*dataLabels: {
                enabled: true
            }*/
        },
        yAxis: {
            allowDecimals: false,
            gridLineWidth: 0,
            title: null,
            lineWidth: 0,
            tickWidth: 0,
            minPadding: 0,
            maxPadding: 0,
            visible: false
        },
        plotOptions: {
            bar: {
                stacking: 'normal',
                borderRadius: '0.44vh',

            },
            series: {
                states: {
                    inactive: {
                        opacity: 1
                    }
                },
                animation: {
                    duration: 500
                }
            }
        },
        series: [
            {
                name: 'fem',
                data: chartDataAge['fem'],
                color: {
                    linearGradient: {
                        x1: 0, x2: 1, y1: 0, y2: 1
                    },
                    stops: [
                        [0, '#FF3782'],
                        [1, '#FF37CA']
                    ]
                },
                pctData: chartDataAge['pct'],
                dataLabels: {
                    enabled: true,
                    inside: false,
                    formatter: function() {
                        return this.series.userOptions.pctData[this.point.index] + '%';
                    },
                    crop: false,
                    overflow: 'none',
                    style: {
                        textOutline: 0,
                        color: 'rgba(56, 56, 116, 0.6)',
                        fontFamily: 'Roboto',
                        fontWeight: 500,
                        fontSize: '1.1vh'
                    }
                }
            },
            {
                name: 'mal',
                data: chartDataAge['mal'],
                color: {
                    linearGradient: {
                        x1: 0, x2: 1, y1: 0, y2: 1
                    },
                    stops: [
                        [0, '#19CEDB'],
                        [1, '#16A7E8']
                    ]
                },
                dataLabels: {
                    enabled: false
                },
            },
            /*{
                name: 'pct',
                /!*visible: false,*!/
                data: chartDataAge['pct'],
                dataLabels: {
                    enabled: true
                }
            }*/
        ]
    }

    return {
        'genderchart': genderChart,
        'ageschart': agesChart
    };
}

export let setupChartOrigins = (data) => {

    let filteredData = [];

    for (const mapPoint of data) {

        if (mapPoint['num'] !== 0) {

            filteredData.push([
                mapPoint['country'].toLowerCase(),
                mapPoint['num']
            ]);

        }

    }

    return {

        'config': {

            chart: {
                map: worldMap,
                resetZoomButton: {
                    theme: {
                        display: 'none'
                    }
                },
                margin: [0, 0, 0, 0]
            },
            title: {
                text: null
            },
            legend: {
                enabled: false
            },
            credits: {
                enabled: false
            },
            tooltip: {
                useHTML: true,
                backgroundColor: null,
                borderWidth: 0,
                shadow: false,
                shared: false,
                formatter: tooltipFormatter
            },
            colorAxis: {
                min: 0,
                minColor: '#a0c7ff',
                maxColor: '#00415f'
            },
            mapNavigation: {
                enabled: true,
                enableButtons: false
            },
            plotOptions: {
                series: {
                    borderColor: '#f6f6f6'
                }
            },
            series: [{
                name: 'origins',
                data: filteredData
            }]

        },
        'zoom': 0

    };

}


export let handleKeyword = (data) => {

    let keywordsMap = {}

    for (const [kwpId, kwpValues] of Object.entries(data)) {

        for (const [kwhId, kwHistory] of Object.entries(kwpValues)) {

            let keywordData = [];

            if (kwHistory['total'] === 0) {

                continue;
            }

            for (const [historyMonth, historyValue] of Object.entries(kwHistory['history'])) {

                keywordData.push(historyValue);
            }

            let chartConfig = {

                chart: {
                    type: 'area',
                    margin: 0,
                    skipClone: true
                },
                title: {
                    text: null
                },
                credits: {
                    enabled: false
                },
                xAxis: {
                    labels: {
                        enabled: false
                    },
                    title: {
                        text: null
                    },
                    startOnTick: false,
                    endOnTick: false,
                    tickPositions: []
                },
                yAxis: {
                    endOnTick: false,
                    startOnTick: false,
                    labels: {
                        enabled: false
                    },
                    title: {
                        text: null
                    },
                    tickPositions: []
                },
                legend: {
                    enabled: false
                },
                tooltip: {
                    enabled: false
                },
                plotOptions: {
                    series: {
                        animation: false,
                        lineWidth: 2,
                        shadow: false,
                        states: {
                            hover: {
                                lineWidth: 2
                            }
                        },
                        marker: {
                            enabled: false,
                            states: {
                                hover: {
                                    enabled: false
                                }
                            }
                        },
                        fillOpacity: 0.25
                    }
                },
                series: [
                    {
                        data: keywordData,
                        color: (kwHistory['sentiment'] === 'pos') ? 'rgba(105, 236, 170, 0.8)' : 'rgba(249, 64, 129, 0.8)',
                        /*pointStart: 1*/
                    }
                ]
            };

            keywordsMap[kwhId] = {
                'sentiment': kwHistory['sentiment'],
                'total': kwHistory['total'],
                'history': kwHistory['history'],
                'chartconfig': chartConfig
            };

        }
    }



    return keywordsMap;

}


